import { API } from "config";
import request from "utilities/request";

const baseUrl = API.metricsApi.url;

export async function redactChatRecord(
  chatThreadId: string,
  getAccessToken: () => Promise<string>
) {
  // Do nothing if baseUrl is null. This makes it easy to disable metrics
  // requests when running locally.
  if (baseUrl === null) return;

  const accessToken = await getAccessToken();
  const url = `${baseUrl}/analytics/chat-record/redact`;
  const method = "POST";

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };
  const body = JSON.stringify({ chat_thread_id: chatThreadId });
  const options = { method, headers, body };

  const response = await request(url, options);
  const responseJson = await response.json();
  return responseJson as { redacted_count: number };
}
